import React, { useCallback, useEffect, useState } from 'react';

import { Container, Score, ScoreText } from './styles';
import useStoreTranslation from 'hooks/useStoreTranslation';

interface Props {
  scores: { text: string; count: number }[];
  values: string;
  onChange: (values: string) => void;
  onOptionChange?: (value: string, isChecked: boolean) => void;
}

const Scores = ({ scores, values, onChange, onOptionChange }: Props) => {
  const isActive = useCallback((checkValue: string) => values === checkValue, [values]);
  const { t } = useStoreTranslation();
  
  const handleClick = (newValue: string) => {
    const active = isActive(newValue);
    const updatedValue = active ? '' : newValue;
    onChange(updatedValue);

    if (onOptionChange) onOptionChange(newValue, !active);
  };

  const [hasSingleChild, setHasSingleChild] = useState(false);

  useEffect(() => {
    const container = document.getElementById('score-container');
    if (container) {
      setHasSingleChild(container.childElementCount === 1);
    }
  }, [scores]);

  return (
    <Container id="score-container" hasSingleChild={hasSingleChild}>
      {scores.map((score) => (
        <Score
          key={score.text}
          className={isActive(score.text) ? 'active' : ''}
          onClick={() => handleClick(score.text)}
        >
          {score.text} 
          
          <br />&nbsp;{t('hotelsCard.orMore')}&nbsp;<br />

          <ScoreText className={isActive(score.text) ? 'active' : ''}>
            {score.text === '9' ? t('hotelsCard.excellent') : ''}
            {score.text === '8' ? t('hotelsCard.veryGood') : ''}
            {score.text === '7' ? t('hotelsCard.good') : ''}
            {score.text === '6' ? t('hotelsCard.acceptable') : ''}
            {score.text === '5' ? t('hotelsCard.regular') : ''}
          </ScoreText>
        </Score>
      ))}
    </Container>
  );
};

export default Scores;
